import { useEffect, useState } from "react";
import axios from "axios";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from "chart.js";
import Typography from "@mui/material/Typography";
import { CircularProgress, Container, Box } from "@mui/material";
import config from "../config.js"

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend
);

const EmployeeAttendanceChart = () => {
  const [chartData, setChartData] = useState(null);
  const [error, setError] = useState(null);
  const { API_BASE_URL } = config;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/v1/EmployeJson`);
      

        const rawData = response.data.data.Sheet1;

        // Filter out the header and total rows
        const filteredData = rawData.filter(
          (item) => typeof item["__EMPTY"] === "number"
        );

        // Extract labels and data
        const labels = filteredData.map((item) => item["YEAR"]);
        const data = filteredData.map((item) => item["__EMPTY"]);

        setChartData({ labels, data });
      } catch (error) {
        setError(error);
      }
    };

    fetchData();
  }, [API_BASE_URL]); 

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!chartData) {
    return (
      <Container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Container>
    );
  } else {
    const data = {
      labels: chartData.labels,
      datasets: [
        {
          label: "ATTENDENCE",
          data: chartData.data,
          fill: false,
          borderColor: "rgb(75, 192, 192)",
          tension: 0.1,
        },
      ],
    };

    const options = {
      responsive: true,
      plugins: {
        legend: {
          position: "top",
        },
        title: {
          display: true,
          text: "Employee Attendance Chart",
        },
      },
    };

    return (
      <Container>
        <Box sx={{ backgroundColor: "#FF4D4D", padding: 2, borderRadius: 1 }}>
          <Typography sx={{textAlign:"center",color: "#fff"}} variant="subtitle1">
            Employee Attendance Throughout the Years
          </Typography>
        </Box>
        <div
          style={{
            padding: "20px",
            width: "100%",
            height: "80%",
          }}
        >
          <Line data={data} options={options} />
        </div>
      </Container>
    );
  }
};

export default EmployeeAttendanceChart;
